/*emTheme.js*-------------------*/
(function($) {
  var $body = $('body'),
    $nav = $('#site-navigation'),
    $pop = $('#popup'),
    $a = $('#primary'),
    currentLightbox,
    emTheme = {
      init: function() {
        // On cache les éléments affichés pour l'accessibilité.
        //$('[data-hidden]').addClass('visuallyhidden');
        emTheme.initAccessibilityForm();
        emTheme.AccessibilityPreferences();
        $('.hide-if-js').removeClass('hide-if-js');
        var myBypasslinks = Frbypasslinks({
          // String - Container selector, hook for JS init() method
          selector: '.js-fr-bypasslinks'
        });

        lightbox.option({
          'albumLabel' : "%1 sur %2",
          'disableScrolling' : true
        });
        
        $('body').on('click', '[data-disclosure]', function(e) {
          var $current = $(this), cible = $current.attr('aria-controls'), content = $('#' +cible);
          if (!content) return;
          content.toggleClass('show');
          if ($current.attr('aria-expanded') === 'true') {
            $current.attr( 'aria-expanded', 'false' );
            $element = content.find('[tabindex=0]');
            $element.attr('tabindex','-1');
            content.attr('aria-hidden', true);
          }
          else {
            content.removeClass('n-visibility');
            $current.attr( 'aria-expanded', 'true' );
            $element = content.find('[tabindex=-1]');
            console.log($element);
            $element.attr('tabindex','0');
            content.attr('aria-hidden', false);
            //$('#s').focus();
          }
        });
        
        $('body').on('click', '#searchform .close', function(e){
          e.preventDefault();
          $('[data-disclosure').trigger('click');
        });

        $('body').on('click', '#quick-menu', function(e) {
          var $current = $(this);
          if ($current.attr('aria-expanded') === 'true') {
            $current.attr( 'aria-expanded', 'false' );
          }
          else {
            $current.attr( 'aria-expanded', 'true' );
          }
          $('#menu-responsive').trigger('click').focus();
        });

        $('body').on('click', '.quick-search', function(e) {
          var $current = $(this);
          if ($current.attr('aria-expanded') === 'true') {
            $current.attr( 'aria-expanded', 'false' );
          }
          else {
            $current.attr( 'aria-expanded', 'true' );
          }
          $('#btn-header-search').trigger('click').focus();
        });

        $btnP = $('#btn-profil');
        if ($btnP.length) {
          $btnP.click(function(e){
            e.preventDefault();
            $current = $(this),
            $element = $('#masthead').find('.bandeau-acces-profil');
            if ($current.attr('aria-expanded') === 'true') {
              if ( $element.length ) {
                $element.removeClass('js-visible').attr('aria-hidden','true');
                $current.attr( 'aria-expanded', 'false' );
              }
              else {
                $("html,body").animate(
                  { scrollTop: parseInt($('#bandeau-profil').offset().top) },
                  300
                );
                $('#bandeau-profil a:first').trigger('focus');
              }
            }
            else {
              $element.addClass('js-visible').attr('aria-hidden','false');
              $current.attr( 'aria-expanded', 'true' );
            }
          });
        }

        $btnPro = $('#btn-header-profil');
        if ($btnPro.length) {
          $btnPro.click(function( ){
            $btnP.trigger('click');
          });
        }
        
        $btnA = $('#btn-accessibilite');
        if ($btnA.length) {
          $btnA.click(function(e){
            e.preventDefault();
            $current = $(this),
            $element = $current.closest('li').find('ul');
            if ($current.attr('aria-expanded') === 'true') {
              $('#bloc-accessibilite').removeClass('show-accessibility');
              $current.attr( 'aria-expanded', 'false' );
            }
            else {
              $('#bloc-accessibilite').addClass('show-accessibility');
              $current.attr( 'aria-expanded', 'true' );
            }
          });
        }

        $sn = $('#search-nav');
        if ($sn.length) {
          $sn.click( function(e){
            e.preventDefault();
            $('#btn-header-search').trigger('click').trigger('focus');
            $("html,body").animate(
              { scrollTop: parseInt($('#site-navigation').offset().top) },
              300
            );
          });
        }
        
        $qs = $('#menu-acces-rapide-top');
        if ($qs.length) {
          $qsa = $qs.find('a');
          $qsa.click(function(e){
            e.preventDefault();
            var $current = $(this), cible = $current.attr('href');
            if ( $current.closest('li').hasClass('quick-search')) {
              $('#btn-header-search').trigger('click').trigger('focus');
              $("html,body").animate(
                { scrollTop: parseInt($('#site-navigation').offset().top) },
                300
              );
            }
            else {
              $("html,body").animate(
                { scrollTop: parseInt($(cible).offset().top) },
                300
              );
            }
          })
        }

        $open = $("#menu-responsive");
        $open.click(function(e) {
          e.preventDefault();
          $open.toggleClass("is-active");
          if ($open.attr('aria-expanded') === 'true') {
            $open.attr( 'aria-expanded', 'false' );
            $('#quick-menu').attr( 'aria-expanded', 'false' );
            $(document).off('keydown.pressNav');
          }
          else {
            $open.attr( 'aria-expanded', 'true' );
            $('#quick-menu').attr( 'aria-expanded', 'true' );
            emTheme.handleNavFocus();
          }
          $li = $('#masthead').find('li');
          $('body').toggleClass("menu-open");
        });

        $('body').on('click','.action-scroll',function(e) {
          e.preventDefault();
          anchor = $(this).attr("href");
          $("html,body").animate(
            { scrollTop: parseInt($(anchor).offset().top) },
            1000
          );
          if ( 'back-to-top' === $(this).attr('id')) {
            $(anchor).focus();
          }
        });

        ScrollTrigger.create({
          start: "280",
          end : 999999,
          toggleClass: {targets: "#back-to-top", className: "is-active"}  
        });

      },
      initAccessibilityForm : function() {
        var myModal = Frdialogmodal();
        var myAccordion = Fraccordion({
          firstPanelsOpenByDefault: false,
        });
      },
      checkLocalStorage : function() {
        try {
          localStorage.setItem('test', 'test');
          localStorage.removeItem('test');
          return true;
        } catch(e) {
          return false;
        }
      },
      AccessibilityPreferences : function() {
        if ( emTheme.checkLocalStorage() ) {
          
          var storedContrast = localStorage.getItem('storedContrast');
          
          if ( 'plus' == storedContrast ) {
            $('#fort').prop("checked", true);
            $('body').addClass('contrast');
          }
          else {
            $('#standard').prop("checked", true);
            $('body').removeClass('contrast');
          }

          $(document).on('change','input[name="contraste"]', function(){
            var selectedValue = $("input[name='contraste']:checked").val();
            $('body').toggleClass('contrast');
            localStorage.setItem( 'storedContrast', selectedValue );
          });
        }
      },
      handleNavFocus : function() {
        const  focusableElements =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#site-navigation'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
        const firstItemFocusable = document.querySelector('#menu-responsive');
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1];
        
        $(document).on('keydown.pressNav', function(e){
          let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
          if (!isTabPressed) {
            return;
          }
          
          if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstItemFocusable) {
              lastFocusableElement.focus(); // add focus for the first focusable element
              e.preventDefault();
            }
            else if (document.activeElement === firstFocusableElement) {
              firstItemFocusable.focus(); // add focus for the last focusable element
              e.preventDefault();
            }
          } else { // if tab key is pressed
            if (document.activeElement === firstItemFocusable) {
              firstFocusableElement.focus(); // add focus for the first focusable element
              e.preventDefault();
            }
            else if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
              firstItemFocusable.focus(); // add focus for the first focusable element
              e.preventDefault();
            }
          }
        });

        //firstFocusableElement.focus();
      }
    };

  $(document).ready(function() {
    emTheme.init();
  });

  $(".wpcf7-form-control-wrap").hover(function() {
    $(this).children(".wpcf7-not-valid-tip").css("display", "none");
  });

})(jQuery);
